import type { ValueOf } from '@deepcloud/deep-ui-utils'
import type { SupportedLanguage } from '../types'

export const WISH_TICKET_FREQUENCIES = {
  MULTIPLE_PER_DAY: 'multiple_per_day',
  MULTIPLE_PER_WEEK: 'multiple_per_week',
  WEEKLY_MONTHLY: 'weekly_monthly',
  RARELY: 'rarely',
  ONCE: 'once',
} as const

export type WishApplications = string[]

export type WishTicketFrequency = ValueOf<typeof WISH_TICKET_FREQUENCIES>

export type WishTicketPostRequest = {
  email: string
  application: string
  customer_name: string
  customer_license?: string
  description: string
  use_cases: string
  frequency: WishTicketFrequency
  target_audience: string
  benefit: string
  discussed_with_abacus: boolean
  additional_info?: string
  privacy_accepted: boolean
  lang: SupportedLanguage
}
